document.addEventListener('DOMContentLoaded', () => {
	const membershipForm = document.querySelector('.form--membership');

	if (!membershipForm) return;

	const membershipTypeInputs = membershipForm.querySelectorAll('input[type="radio"][name="adhesion[]"]');
	const customMembershipPriceInput = membershipForm.querySelector('input[name="membership_price"]');
	const transferPaymentTypeInput = membershipForm.querySelector('input[type="radio"][name="payment_type[]"][value="transfer"]');
	const cardPaymentTypeInput = membershipForm.querySelector('input[type="radio"][name="payment_type[]"][value="cb"]');

	if (!membershipTypeInputs || !customMembershipPriceInput || !transferPaymentTypeInput || !cardPaymentTypeInput) return;

	membershipTypeInputs.forEach((input) => {
		input.addEventListener('change', () => {
			console.log('change');

			customMembershipPriceInput.required = input.value === 'other';

			if (input.value !== 'other') return;

			transferPaymentTypeInput.checked = false;
			cardPaymentTypeInput.checked = false;
		});
	});
});
